export const storyPreviewModalMessages = {
  title: 'Story Preview',
  dialogTitle: (title: string) => `Story Preview: ${title}`,
  dialogDescription: (title: string, spreadCount: number) =>
    `Preview of story template "${title}" with ${spreadCount} spreads`,
} as const;
